import React from 'react';
import HomeOwnerPoll from "../../../components/pages/form/HomeOwnerPoll/HomeOwnerPoll";

const HomeOwnerPollPage = () => {
    return <HomeOwnerPoll />
};

export default HomeOwnerPollPage;
